// Предишните причини за изписване (GET /inventory/writeoffs/reasons) —
// подсказките на полето „Причина" в листа „Изписване".
//
// ОГЛЕДАЛО на BE: `writeoffReasonKey` повтаря `reason_group_key`
// (`app/features/inventory/service_writeoff_reasons.py`) — две причини са ЕДНА,
// ако съвпадат след свиване на интервалите и малки букви. Авторитетът е BE (той
// групира и записва причината със свити интервали); тук ключът служи на
// полето (избор на вече съществуващото изписване) и на филтъра „Причина" в
// справката „Изписвания". Договорът — ред 22 на docs/cross-repo-contract.md.
import axios from "axios";
import { api } from "./client";

// Една причина от последната година. Изписванията, които се различават само
// по малки/главни букви и интервали, са един ред с изписването от последното
// ползване.
export interface WriteoffReason {
  reason: string;
  count: number; // колко изписвания са с тази причина (за 365 дни)
  lastUsedAt: string; // датата на най-новото (ISO с офсет)
}

// Причината, както BE я записва: без крайни интервали, вътрешните — един
export const collapseReasonWhitespace = (reason: string): string =>
  reason.split(/\s+/).filter(Boolean).join(" ");

// Ключът за групиране/сравнение (огледало на BE `reason_group_key`)
export const writeoffReasonKey = (reason: string | null | undefined): string =>
  collapseReasonWhitespace(reason ?? "").toLowerCase();

// Най-ползваните първи (до 50). BE отпреди endpoint-а отговаря 422 — пътят
// пада в `/writeoffs/{id}` и „reasons" не е число — затова 422 и 404 значат
// „няма подсказки", не грешка.
export async function getWriteoffReasons(): Promise<WriteoffReason[]> {
  try {
    const res = await api.get<WriteoffReason[]>("/inventory/writeoffs/reasons");
    return Array.isArray(res.data) ? res.data : [];
  } catch (error: unknown) {
    const status = axios.isAxiosError(error) ? error.response?.status : undefined;
    if (status === 404 || status === 422) return [];
    throw error;
  }
}
